exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".separator[data-v-55f43f36] {\n  width: 100%;\n  height: 30px;\n  position: relative;\n}\n.separator i[data-v-55f43f36],\n  .separator small[data-v-55f43f36] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: auto;\n    transform: translate(-50%, -50%);\n}\n.separator i[data-v-55f43f36] {\n    width: 80px;\n    display: block;\n    height: 1px;\n    background-color: #333;\n    opacity: 0.5;\n}\n.separator small[data-v-55f43f36] {\n    background-color: #fff;\n    padding: 0 15px;\n}\n", ""]);

// exports
